import { useNavigate } from 'react-router-dom';

export function ProjectsSection() {
  const navigate = useNavigate();
  
  const projects = [
    {
      title: 'Our Mission',
      description: 'To provide world-class marketing, media, and technology solutions that empower individuals, businesses, and organizations to achieve growth, visibility, and measurable success',
      image: 'https://static.readdy.ai/image/8ff5f191f084c4fb11b85d16f9e2729c/da53d9380322dc8eccbe9566bc33a744.jpeg',
      category: 'Mission'
    },
    {
      title: 'Our Vision',
      description: 'To become a leading global brand in marketing and technology, recognized for innovation, trust, and sustainable impact in transforming how businesses and institutions connect with the world',
      image: 'https://public.readdy.ai/ai/img_res/a5c7c017185ea2f90e9ab9bd9156f4dd.jpg',
      category: 'Vision'
    },
    {
      title: 'Our Story',
      description: 'Founded on the belief that every business deserves access to modern solutions combining creativity with functionality. We evolved from marketing to a multi-disciplinary agency offering end-to-end services, cementing our place as a forward-looking brand committed to innovation',
      image: 'https://readdy.ai/api/search-image?query=Company%20growth%20and%20evolution%20timeline%20concept%2C%20modern%20business%20journey%20visualization%20with%20technology%20and%20creativity%20elements%2C%20purple%20and%20violet%20gradient%20showing%20progression%20and%20development%2C%20sleek%20professional%20representation%20of%20business%20transformation%20story&width=900&height=600&seq=tehkzone008&orientation=landscape',
      category: 'Story'
    },
    {
      title: 'Our Commitment',
      description: 'More than just a marketing and technology company, we are a strategic partner for businesses seeking sustainable growth. Our blend of creativity, innovation, and technical expertise ensures we exceed expectations and shape the future of business',
      image: 'https://readdy.ai/api/search-image?query=Strategic%20partnership%20and%20business%20commitment%20concept%2C%20handshake%20and%20collaboration%20in%20modern%20corporate%20setting%2C%20purple%20and%20violet%20professional%20lighting%20showing%20trust%20and%20dedication%2C%20sleek%20minimalist%20representation%20of%20business%20partnership%20excellence&width=900&height=600&seq=tehkzone009&orientation=landscape',
      category: 'Commitment'
    }
  ];

  const handleCardClick = () => {
    navigate('/who-we-are');
  };

  return (
    <section id="projects" className="py-16 sm:py-20 md:py-24">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extralight text-white mb-4 sm:mb-6 tracking-[0.1em]">
            Who We Are
          </h2>
          <p className="text-gray-400 text-base sm:text-lg font-light max-w-3xl mx-auto px-4">
            Our foundation, direction, and commitment to transforming businesses
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {projects.map((project, index) => (
            <div 
              key={index}
              onClick={handleCardClick}
              className="group relative bg-black/30 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden transition-all duration-500 hover:border-purple-400/50 hover:scale-[1.02] cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-56 sm:h-64 md:h-72 overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent"></div>
                
                {/* Category Badge */}
                <div className="absolute top-4 sm:top-6 left-4 sm:left-6">
                  <span className="px-3 sm:px-4 py-1.5 sm:py-2 bg-violet-500/20 backdrop-blur-sm border border-violet-400/30 rounded-lg text-violet-300 text-xs font-light">
                    {project.category}
                  </span>
                </div>
              </div>
              
              {/* Content */}
              <div className="p-6 sm:p-8">
                <h3 className="text-xl sm:text-2xl font-light text-white mb-3 sm:mb-4 tracking-wide">
                  {project.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed font-light">
                  {project.description}
                </p>
              </div>
              
              {/* Hover Effect */}
              <div className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-violet-400 to-purple-400 group-hover:w-full transition-all duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
